// extracted by mini-css-extract-plugin
module.exports = {"Panel":"mobile-header_Panel__ee7MV","Top":"mobile-header_Top__pLzNJ","Scrolled":"mobile-header_Scrolled__Kdr_a"};